import { render, staticRenderFns } from "./ControllerPage.vue?vue&type=template&id=7511d77f&scoped=true&"
import script from "./ControllerPage.vue?vue&type=script&lang=js&"
export * from "./ControllerPage.vue?vue&type=script&lang=js&"
import style0 from "./ControllerPage.vue?vue&type=style&index=0&id=7511d77f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7511d77f",
  null
  
)

export default component.exports